export default __webpack_public_path__ + "static/media/no-learning-track.e78ebce1.svg";